import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=288a2f64&scoped=true"
import script from "./DeliveryNote.vue?vue&type=script&lang=js"
export * from "./DeliveryNote.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNote.vue?vue&type=style&index=0&id=288a2f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a2f64",
  null
  
)

export default component.exports